import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/images/illustrations/warning.png'


const _hoisted_1 = { class: "_modal bg-white" }
const _hoisted_2 = { class: "_modal__content md-down:px-4 px-12 py-6 flex flex-col items-center justify-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "Luca Education",
    title: "Luca Education",
    height: "60",
    width: "60"
  })
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "_modal__content__title text-neutral-700 font-semibold text-2xl mt-5 text-center" }, " Bạn có muốn xoá thông tin Phụ huynh này? ", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "text-center text-neutral-500 mt-2" }, " Người chăm sóc bị xoá sẽ không thể xem thông tin và báo cáo kết quả của học sinh ", -1)
const _hoisted_6 = {
  key: 0,
  class: "w-full mt-10"
}
const _hoisted_7 = { class: "input-group grid grid-cols-1 md:grid-cols-2 items-center" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "input-group__label md-down:text-center text-neutral-500 font-normal" }, " Mối quan hệ với H.S ", -1)
const _hoisted_9 = { class: "font-bold text-neutral-500 text-center md:text-right" }
const _hoisted_10 = { class: "input-group grid grid-cols-1 md:grid-cols-2 items-center mt-8" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "input-group__label md-down:text-center text-neutral-500 font-normal" }, " Email ", -1)
const _hoisted_12 = { class: "font-bold text-neutral-500 text-center md:text-right" }
const _hoisted_13 = { class: "input-group grid grid grid-cols-1 md:grid-cols-2 items-center mt-8" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "input-group__label md-down:text-center text-neutral-500 font-normal" }, " Học sinh ", -1)
const _hoisted_15 = { class: "font-bold text-neutral-500 text-center md:text-right" }
const _hoisted_16 = { class: "_modal__footer px-12 py-6 bg-neutral-50 flex flex-nowrap items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _hoisted_5,
      (_ctx.popupData)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.popupData.parent), 1)
            ]),
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.popupData.email), 1)
            ]),
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.popupData.student), 1)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("button", {
        type: "button",
        class: "button-p text-center mr-3 bg-none shadow-none text-neutral-500 hover:text-neutral-700",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
      }, " Thoát "),
      _createElementVNode("button", {
        type: "button",
        class: "button-p text-center whitespace-nowrap",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
      }, " Xác nhận ")
    ])
  ]))
}